import { InfoCircleOutlined, PlusCircleOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import {
    Button,
    Checkbox,
    Col,
    Empty,
    Form,
    notification,
    Radio,
    Row,
    Select,
    Space,
    Table,
    Tag,
    Tooltip,
    Upload
} from "antd";
import { useEffect, useState } from "react";
import { getMacTemplateCustomScript, addMacTemplateCustomScript,deleteMacTemplateCustomScript } from "../../../axios/api.device";

import i18n from "@src/locales";
import { useTranslation } from "react-i18next";

const { Column } = Table
const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateMacContentCustomScript = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props
    const [showTable, setShowTable] = useState<number>(0)
    // const [isSave, setIsSave] = useState<boolean>(true)
    const [isDisabled, setIsDisabled] = useState<boolean>(true)
    const [file, setFile] = useState<any>()
    const [dataForm] = Form.useForm()

    const { t } = useTranslation();

    var addClick = () => {
        setShowTable(2)
    }

    useEffect(() => { getDataInfo() }, [])
    
    const getDataInfo = () => {
        if (platform !== "Android") {
            getMacTemplateCustomScript(templateId).then(
                (res) => {
                    if (res) {
                        const arg = {
                            uid: res.id,
                            name: res.name,
                            status: 'done',
                            url: res.ossUrl
                        }
                        setFile([arg])
                        // setIsSave(true)
                        setIsDisabled(false)
                        setShowTable(2)
                    }
                    else {
                        setFile([])
                        setIsDisabled(true)
                        setShowTable(1)
                    }
                    
                },
                () => {
                    notification.error({message: t("获取自定义脚本文件失败")})                    
                }
            )
        }
    }

    const uploadFile = (res: any) => {
        const { fileList } = res
        if (fileList.length > 0) {
            // setIsSave(false)
            setFile(fileList[0].originFileObj)
        } 
        else {
            // setIsSave(true)
            setFile("")
        }
    }

    const addTemplateClick = () => {
        dataForm?.validateFields().then(
            () => {                
                if (platform !== "Android") {
                    addMacTemplateCustomScript(templateId, {File: file}).then(
                        () => {
                            updateTemplate();
                            notification.success({ message: t("成功") });
                            getDataInfo();
                        }, 
                        () => {
                            notification.error({ message: t("保存失败") })
                        }
                    )
                }
            }
        )
    }

    const deleteTemplateClick = () => {
        if (platform !== "Android") {
            deleteMacTemplateCustomScript(templateId).then(
                () => {
                    updateTemplate();
                    notification.success({ message: t("成功") });
                    dataForm.resetFields();
                    getDataInfo();
                },
                () => {
                    notification.error({ message: t("删除失败") })
                }
            )
        }
    }

    const normFile = (e: any) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    }

    return (
        <>
            <div>
                <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                    <Col className="templateTitle">{t("自定义脚本")}</Col>
                    {platform != "Android" && (
                        <Col style={{ marginLeft: 36 }}>
                            {templateTab?.availabilities.map((c: any) => (
                                <Tooltip title={
                                    i18n.language === "zh" ? `只能在${c}以上的设备上才能配置` : 
                                    i18n.language === "en" ? `Only be configured on devices above iOS ${c}` : ""
                                }>
                                    <Tag color="cyan">{c}</Tag>
                                </Tooltip >
                            ))}
                            {templateTab?.supervisedRequired && (
                                <Tooltip title={t("只适用于受监督设备")}>
                                    <Tag color="purple">S</Tag>
                                </Tooltip>
                            )}
                        </Col>
                    )}
                </Row>
                <Row><div className="dividerStyle"></div></Row>
                <Row style={{ margin: "16px 16px 16px 0px" }}>
                    {showTable == 1 && (
                        <div>
                            <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                                {t("添加自定义脚本文件，直接上传到设备上执行")}
                            </p>
                            <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                                <Button onClick={() => { addClick(); }} type="primary">
                                    <PlusOutlined /> {t("添加规则")}
                                </Button>
                            </div>
                        </div>
                    )}
                    {showTable == 2 && (
                        <>
                            <Form
                                style={{ width: "90%", marginTop: 36, marginLeft: 45 }}
                                layout="vertical"
                                form={dataForm}
                                labelCol={{ span: 24 }}
                                // initialValues={{ file: "" }}
                            >
                                <Item 
                                    label={t("自定义的脚本文件")} 
                                    name="file" 
                                    valuePropName="fileList"
                                    getValueFromEvent={normFile}
                                    extra={<><InfoCircleOutlined /> {t("支持.sh文件后缀")}</>}
                                    rules={[{ required: true }]}
                                >
                                    <Upload
                                        accept=".sh"
                                        listType="text"
                                        showUploadList={true}
                                        beforeUpload={() => {
                                            return false;
                                        }}
                                        maxCount={1}
                                        onChange={uploadFile}
                                        defaultFileList={file}
                                        onRemove={() => { 
                                            if (!isDisabled) {
                                                deleteTemplateClick();
                                            }
                                         }}
                                    >
                                        {isDisabled ? <Button icon={<UploadOutlined />}>{t("点击上传")}</Button> : null}
                                    </Upload>
                                </Item>
                            </Form>
                            <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "80%" }}>
                                <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); }}> {t("保存")} </Button>
                                <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick();  }}>{t("删除规则")}</Button>
                            </div>
                        </>
                    )}
                </Row>
            </div>
        </>
    )
};